export function useEnvironment() {
  return {
    isDev: process.env.DEVELOPMENT_TYPE === 'local',
    isSandbox: process.env.DEVELOPMENT_TYPE === 'sandbox',
    isProduction: process.env.DEVELOPMENT_TYPE === 'production',
  }
}
